import BenefitsHero from './BenefitsHero';

export default BenefitsHero;
